"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Installments_1 = require("./Installments");
exports.default = Installments_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/Installments/index.js
// module id = 150
// module chunks = 0 1